import React from "react";
import {Outlet, useLocation, matchPath} from "react-router-dom";
import AdminHeader from "./partials/AdminHeader";
import AdminFooter from "./partials/AdminFooter";

function AdminPortal() {
    const location = useLocation();
    const hideHeaderFooter =
        matchPath("/back-admin/template/:templateUuid", location.pathname) ||
        matchPath("/back-admin/template/:templateUuid/edit-questions", location.pathname);

    return (
        <div className="wrapper manage_page admin-portal">
             <AdminHeader/>
            <section className="main-wrapper-admin section--color" style={{minHeight: 'calc(100vh - 56px)'}}>
                <Outlet/>
            </section>
            {/* {!hideHeaderFooter && <AdminFooter/>} */}
        </div>
    );
}

export default AdminPortal;